
const Layout = () => import ( `@/page/index/index.vue`);
import demo from './demo/demo';
import usermanage from './usermanage/usermanage';
import cusmanage from './cusmanage/cusmanage';
import drivermanage from './drivermanage/drivermanage';
import ordermanage from './ordermanage/ordermanage';
import subRouter from './subrouter';
import apprmanage from './apprmanage/apprmanage';
import sysmanage from './sys/index';
import projectmanage from './projectmanage/projectmanage';
let rou = subRouter.concat(demo)
rou = rou.concat(usermanage)
rou = rou.concat(cusmanage)
rou = rou.concat(drivermanage)
rou = rou.concat(ordermanage)
rou = rou.concat(apprmanage)
rou = rou.concat(sysmanage)
rou = rou.concat(projectmanage)
export default [
  {
    path: '/',
    name: '主页',
    redirect: '/login',
  },
  {
    path: '/',
    component: Layout,
    children:rou,
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
  {
    path: '/:tenant/login',
    name: '登录',
    component: () => import ( /* webpackChunkName: "login" */ `@/page/new-login/index.vue`),
  },
  {
    path: '/login',
    name: '登录',
    component: () => import ( /* webpackChunkName: "login" */ `@/page/new-login/index.vue`),
  },
  {
    path: '/lock',
    name: '锁屏',
    component: () => import ( /* webpackChunkName: "lock" */ `@/page/lock/index.vue`),
  },

  {
    path: '/404',
    component: () => import ( /* webpackChunkName: "404" */ `@/components/ciic/error-page/404.vue`),
    name: '404',
  },
  {
    path: '/403',
    component: () => import ( /* webpackChunkName: "403" */ `@/components/ciic/error-page/403.vue`),
    name: '403',
  },
  {
    path: '/500',
    component: () => import ( /* webpackChunkName: "500" */ `@/components/ciic/error-page/500.vue`),
    name: '500',
  },
];
